// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-k_ha","advertDetailContacts__header":"c-k_hb"};